import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Link as DSLink } from '@digdir/designsystemet-react';
import { ExternalLinkIcon } from '@navikt/aksel-icons';
import { Link } from 'react-router-dom';

import Logo from '../../../../assets/images/logo.svg?react';
import Linkedin from '../../../..//assets/icons/social/linkedin.svg?react';
import Facebook from '../../../..//assets/icons/social/facebook.svg?react';
import Instagram from '../../../..//assets/icons/social/instagram.svg?react';
import Youtube from '../../../..//assets/icons/social/youtube.svg?react';

import {
  BottomLinksContainer,
  CenteredContainer,
  CopyrightContainer,
  FooterContent,
  LinkColumn,
  LinkContainer,
  LogoContainer,
  StyledDivider,
  StyledFooter
} from './styledComponents';

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  noIcon?: boolean;
}

const ExternalLink: FC<ExternalLinkProps> = ({ href, children, noIcon }) => (
  <DSLink target="_blank" rel="noopener noreferrer" href={href}>
    {children}
    {!noIcon && <ExternalLinkIcon fontSize="1.4rem" />}
  </DSLink>
);

const Footer: FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <StyledFooter>
      <CenteredContainer>
        <LogoContainer>
          <Logo aria-label="Enova" />
        </LogoContainer>
        <FooterContent>
          <LinkContainer>
            <LinkColumn>
              <Heading data-size="xs">{t('footer.heading.shortcuts')}</Heading>
              <ExternalLink href="https://enova.no/nb/energimerking/om-energimerkeordningen-2026">
                {t('footer.shortcuts.about')}
              </ExternalLink>
              <ExternalLink href="https://enova.no/nb/energimerking/energimerk-din-bolig">
                {t('footer.shortcuts.guide')}
              </ExternalLink>
              <ExternalLink href="https://enova.no/nb/privat">{t('footer.shortcuts.subsidies')}</ExternalLink>
            </LinkColumn>
            <LinkColumn>
              <Heading data-size="xs">{t('footer.heading.info')}</Heading>
              <ExternalLink href="https://enova.no/nb/om-oss/hvem-er-enova/kontakt-oss">
                {t('footer.contact.kontaktoss')}
              </ExternalLink>
              <ExternalLink href="https://enova.no/nb/om-oss">Om Enova</ExternalLink>
              <DSLink asChild>
                <Link to="/statistikk">{t('footer.statistics')}</Link>
              </DSLink>
            </LinkColumn>
            <LinkColumn>
              <Heading data-size="xs">{t('footer.heading.follow')}</Heading>
              <ExternalLink noIcon href="https://www.linkedin.com/company/enova-sf">
                <Linkedin /> Linkedin
              </ExternalLink>
              <ExternalLink noIcon href="https://www.facebook.com/enova.no/">
                <Facebook /> Facebook
              </ExternalLink>
              <ExternalLink noIcon href="https://www.instagram.com/enovasf/">
                <Instagram /> Instagram
              </ExternalLink>
              <ExternalLink noIcon href="https://www.youtube.com/user/EnovaNO">
                <Youtube /> Youtube
              </ExternalLink>
            </LinkColumn>
          </LinkContainer>
        </FooterContent>
        <StyledDivider />
        <CopyrightContainer>Copyright © {currentYear} All rights reserved.</CopyrightContainer>
        <BottomLinksContainer>
          <ExternalLink href="https://enova.no/nb/om-oss/hvem-er-enova/prinsipper-etterlevelse/enova-og-personvern/cookies">
            {t('footer.privacyAndCookies')}
          </ExternalLink>
          <ExternalLink href="https://uustatus.no/nn/erklaringer/publisert/418ded37-2b86-415b-b272-c490044a7cbb">
            {t('footer.accessibility')}
          </ExternalLink>
        </BottomLinksContainer>
      </CenteredContainer>
    </StyledFooter>
  );
};

export default Footer;
